// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import productDescriptionVariantStyles from "@conklin/App/SharedStyles/ProductDescriptionStyles";
import { LazyImageStyle } from "@conklin/MobiusOverrides/LazyImage";
import { productCarouselProductCondensedStyles } from "@conklin/Overrides/Components/ProductCarouselProductCondensed";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.productImageStyles = {
    linkWrappingImage: {
        css: css`
            height: 91px;
        `,
    },
    img: {
        css: css`
            aspect-ratio: 1;
            object-fit: contain;
        `,
    },
};
productCarouselProductCondensedStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 317px;
            border: 0;
            padding: 0;

            ${xScreen("lte", "md")} {
                max-width: 358px;
            }

            ${xScreen("lte", "sm")} {
                max-width: 328px;
            }

            & > .top-section {
                display: flex;
                flex-direction: row;
                column-gap: 12px;
                & > .info-section {
                    max-width: calc(100% - 104px);
                }
                & > .image-section {
                    margin-bottom: 0;
                }
            }
        `,
    },
    image: {
        css: css`
            position: relative;
            width: 91px;
            height: 100%;
            margin: 0 auto;
        `,
    },
};

productCarouselProductCondensedStyles.badges = {
    css: css`
        margin-top: 8px;
        margin-bottom: 8px;
    `,
};
productCarouselProductCondensedStyles.productBrandWrapper = {};

productCarouselProductCondensedStyles.textBadgeStyle = {
    badgeText: {
        size: 10,
        lineHeight: "12px",
        color: "common.white",
        weight: fontConfig.weight.bold,
    },
    badge: {
        css: css`
            margin: 0;
            & > div {
                display: flex;
                width: fit-content;
            }
        `,
    },
};
productCarouselProductCondensedStyles.productDescriptionStyles = {
    ...mergeWithCss(productDescriptionVariantStyles.small, {
        productDetailLink: {
            typographyProps: {
                css: css`
                    ${ellipsis(2)}
                `,
            },
        },
        productDetailDescription: {
            css: css`
                ${ellipsis(2)}
            `,
        },
    }),
};

productCarouselProductCondensedStyles.productAddToListLinkStyles = {
    link: {
        css: css`
            margin-left: auto;
        `,
    },
};
productCarouselProductCondensedStyles.productAvailabilityStyles = {
    messageGridItem: {
        width: 12,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
    },
    availabilityByWarehouseLink: {
        css: css`
            margin-left: 0;
        `,
    },
};
productCarouselProductCondensedStyles.productPriceWrapper = {};

productCarouselProductCondensedStyles.productPriceStyles = {
    price: {
        priceText: {
            size: 18,
            lineHeight: "22px",
            weight: fontConfig.weight.black,
            css: css`
                &&& {
                    line-height: 22px;
                }
            `,
        },
    },
};

productCarouselProductCondensedStyles.productActions = {
    productAddToCartButtonStyles: {
        sizeVariant: "small",
    },
    addToCartContainer: {
        css: css`
            min-width: 100%;
        `,
    },
};

productCarouselProductCondensedStyles.badgeTextWrapper = {
    css: css`
        &&&& {
            position: static;
            margin-top: 8px;
        }
    `,
};

productCarouselProductCondensedStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin-bottom: 8px;
        `,
    },
    erpNumberLabelText: { size: 12 },
    erpNumberValueText: { size: 12 },
    manufacturerItemLabelText: {
        size: 12,
        css: css`
            white-space: nowrap;
        `,
    },
};

productCarouselProductCondensedStyles.badgeImageWrapper = {
    css: css`
        ${LazyImageStyle} {
            max-width: 23px;
            max-height: 23px;
            margin-top: 4px;
            margin-right: 4px;

            img {
                max-width: 100%;
            }
        }
    `,
};
